import forEach from "lodash/forEach";
import get from "lodash/get";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import isMap from "lodash/isMap";
import isRegExp from "lodash/isRegExp";
import keys from "lodash/keys";
import some from "lodash/some";
const createMiddleware = () => {
    const listeners = [];
    const subscriptions = [];
    const subscriptionValues = {};
    const middleware = (store) => (next) => (action) => {
        const result = next(action);
        if (action.type) {
            forEach(listeners, listener => {
                listener.forEach((callback, key) => {
                    if ((isRegExp(key) && key.test(action.type)) || key === action.type) {
                        callback(action, store.dispatch, store.getState);
                    }
                });
                forEach(subscriptions, subscription => {
                    forEach(subscription, (callback, path) => {
                        const previousValue = subscriptionValues[path];
                        subscriptionValues[path] = get(store.getState(), path);
                        if (previousValue !== subscriptionValues[path]) {
                            callback(previousValue, subscriptionValues[path], store.dispatch, store.getState);
                        }
                    });
                });
            });
        }
        return result;
    };
    middleware.addListener = (runner) => {
        const runnerAsMap = isMap(runner) ? runner : new Map(Object.entries(runner));
        const types = Array.from(runnerAsMap.keys());
        if (some(types, t => !isRegExp(t) && (isEmpty(t) || includes(t, "undefined")))) {
            throw new Error(`One or more incorrect action types were found when 'addListener'. Actions types are: ${types}`);
        }
        listeners.push(runnerAsMap);
    };
    middleware.addSubscription = (runner) => {
        if (some(keys(runner), k => isEmpty(k) || includes(k, "undefined"))) {
            throw new Error(`One or more incorrect paths were found when 'addSubscription'. Path are: ${keys(runner)}`);
        }
        subscriptions.push(runner);
    };
    return middleware;
};
export default createMiddleware();
